import { IFilter } from "../interfaces/filter";

export const filterDefault: IFilter = {
    category: {
        [`electronics`]: false,
        [`men's clothing`]: false,
        [`jewelery`]: false,
        [`women's clothing`]: false,
    },
    rate: {
        [`1`]: false,
        [`2`]: false,
        [`3`]: false,
        [`4`]: false,
        [`5`]: false,
    },
    price: {
        min: 0,
        max: 1000,
    },
    counts: {
        min: 0,
        max: 500,
    },
    search: '',
    sort: {
        by: '',
        order: '',
    },
}